<template>
    <div>
        <ion-item>
            <ion-label
                :position="placeholder === undefined ? 'floating' : 'stacked'"
                v-if="label !== ''"
                >{{ label }}</ion-label
            >
            <ion-input
                :type="overriddenType || type"
                :value="value"
                @ionChange="$emit('input', $event.detail.value)"
                :debounce="debounce"
                :placeholder="placeholder"
                :min="min"
                :inputmode="inputmode"
                clear-on-edit="false"
                v-if="Object.keys(mask).length === 0"
                :disabled="disabled"
                :clear-input="clearInput"
                :autocapitalize="autocapitalize"
            ></ion-input>
            <ion-input
                :type="overriddenType || type"
                :value="value"
                @ionChange="$emit('input', $event.detail.value)"
                :debounce="debounce"
                :placeholder="placeholder"
                :min="min"
                :inputmode="inputmode"
                clear-on-edit="false"
                :disabled="disabled"
                v-imask="mask"
                v-else
                :clear-input="clearInput"
                @accept="onAccept"
                :autocapitalize="autocapitalize"
            ></ion-input>
            <ion-button
                fill="clear"
                slot="end"
                @click="toggleType()"
                v-if="type === 'password'"
                color="dark"
            >
                <ion-icon :name="buttonIcon" slot="icon-only"></ion-icon>
            </ion-button>
            <ion-button
                fill="clear"
                slot="end"
                @click="showInfo()"
                v-if="infoText !== ''"
                color="dark"
            >
                <ion-icon
                    name="information-circle-outline"
                    slot="icon-only"
                ></ion-icon>
            </ion-button>
        </ion-item>
        <input-error v-if="hasInputErrorField" :id="id"></input-error>
    </div>
</template>

<script>
import InputError from "./InputError";
import { IMaskDirective } from "vue-imask";

export default {
    directives: { imask: IMaskDirective },
    components: {
        InputError,
    },
    props: {
        value: undefined,
        label: {
            type: String,
            required: false,
            default: "",
        },
        placeholder: String,
        min: String,
        id: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        multiple: {
            type: Boolean,
            required: false,
            default: false,
        },
        inputmode: {
            default: undefined,
            required: false,
        },
        infoText: {
            type: String,
            required: false,
            default: "",
        },
        hasInputErrorField: {
            type: Boolean,
            required: false,
            default: true,
        },
        debounce: {
            type: Number,
            required: false,
            default: 0,
        },
        mask: {
            type: Object,
            required: false,
            default: function () {
                return {};
            },
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        clearInput: {
            type: Boolean,
            required: false,
            default: false,
        },
        autocapitalize: {
            type: String,
            required: false,
            default: "on",
        },
    },
    data() {
        return {
            overriddenType: false,
            buttonIcon: "eye-off",
        };
    },
    methods: {
        onAccept(event) {
            this.$emit("onAccept", event.detail.unmaskedValue);
        },
        showInfo() {
            this.$ionic.alertController
                .create({
                    header: "Hinweis",
                    message: this.infoText,
                    buttons: ["Ok"],
                })
                .then((a) => {
                    a.present();
                });
        },
        toggleType() {
            if (!this.overriddenType) {
                this.overriddenType = "text";
                this.buttonIcon = "eye";
            } else {
                this.overriddenType = false;
                this.buttonIcon = "eye-off";
            }
        },
    },
};
</script>

<style lang="scss" scoped>
ion-label {
    // --color: var(--ion-color-medium-shade) !important;
    opacity: 0.33;
}
.label-floating.sc-ion-label-md-h,
.label-stacked.sc-ion-label-md-h {
    padding-top: 8px;
}
.item-has-value {
    ion-label {
        opacity: 1;
        // --color: var(--ion-color-dark) !important;
    }
}

ion-button {
    transform: translate3d(0, 30px, 0);
}

// ion-input {
//   --placeholder-color: var(--ion-color-medium);
// }
</style>
